<template>
  <bioreq-table ref="table" :view="view" table-type="processed"/>
</template>

<script>
import { mapState } from 'vuex'
import bioreqTable from './processedTable'

export default {
  components: {
    bioreqTable
  },
  computed: {
    ...mapState('bioreq', {
      view: '_processedView'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/bioreq/processed.vue